import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Card from "./Card";

function Services() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="container services py-5">
      <h2 className="main-title text-center mb-4" data-aos="fade-up">SERVICES</h2>

      <div className="card-cover">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-4 mb-2" data-aos="fade-up" data-aos-delay="100">
              <Card
                title="Category-Based Sourcing"
                img="sourcing.png"
                text="We provide sourcing services tailored for fragrances, common kitchen essentials, and clothing—curated to meet your unique business or personal needs."
              />
            </div>
            <div className="col-md-4 mb-2" data-aos="fade-up" data-aos-delay="400">
              <Card
                title="eCommerce Setup & Fulfillment"
                img="shopping.png"
                text="From seamless online shopping systems to backend logistics, we support the full eCommerce pipeline for lifestyle essentials."
              />
            </div>
            <div className="col-md-4 mb-2" data-aos="fade-up" data-aos-delay="700">
              <Card
                title="After-Sales & Customer Support"
                img="support.png"
                text="We manage customer communication, issue resolution, and feedback loops to ensure consistent service satisfaction."
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services;
